var exports = {
  "q9": "xa15a2ab7--d47d68--price",
  "vj": "xa15a2ab7--d47d68--amount",
  "b6": "xa15a2ab7--d47d68--history",
  "id": "xa15a2ab7--d47d68--discount",
  "mG": "xa15a2ab7--d47d68--inline",
  "bC": "xa15a2ab7--d47d68--hide-if-empty",
  "yw": "xa15a2ab7--d47d68--purchase-terms",
  "fO": "xa15a2ab7--d47d68--full-price-payment",
};

module.exports = exports;
